import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import styled from 'styled-components';

/*
  Styled components
 */
const Container = styled.div`
  min-width: 320px;
  max-width: 400px;
  text-align: center;
  height: auto;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  margin: auto;
`;

const Loading = () => (
  <Container>
    <CircularProgress />
  </Container>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js